export const COLORS = {
  NEUTRAL_600: '#706f6f',
  NEUTRAL_700: '#666666',
  NEUTRAL_800: '#3e3e3e',
}
